const { pushState, replaceState } = window.history;

const dispatchLocationChanged = (eventName, args) => {
  const data = {
    eventName,
    data: args,
  };

  window.dispatchEvent(new window.CustomEvent('locationChange', data));
  if (eventName !== 'popstate') {
    window.dispatchEvent(new window.CustomEvent('locationNewState', data));
  }
};

window.history.pushState = (...args) => {
  pushState.apply(window.history, args);
  dispatchLocationChanged('pushState', args);
};

window.history.replaceState = (...args) => {
  replaceState.apply(window.history, args);
  dispatchLocationChanged('replaceState', args);
};

window.addEventListener('popstate', (...args) => {
  dispatchLocationChanged('popstate', args);
});
